import { Controller } from '@hotwired/stimulus'
import SmoothScroll from 'smooth-scroll'
import parsePhoneNumber from 'libphonenumber-js/max'

export default class extends Controller {
  static targets = ['prefectures', 'cities', 'fee', 'occupantTimings', 'dementia', 'profile', 'telInput', 'telError', 'submit', 'modal', 'modalBack', 'modalFee', 'modalArea', 'modalPrefectures', 'modalPrefecturesContent', 'modalCities', 'modalCitiesContent', 'modalOccupantTimings', 'modalDementia', 'modalProfile']

  initialize () {
    this.scroll = new SmoothScroll()
  }

  disconnect () {
    this.prefecturesTarget.removeEventListener('change', this.changePrefecture)
  }

  closeModalBack () {
    this.modalTarget.style.display = 'none'
  }

  updateCities (cities) {
    this.citiesTarget.innerHTML =
      '<option value="">市区町村を選択してください</option>' +
      cities.map((city) => (
        `<option value="${city.id}">${city.name}</option>`
      )).join()
  }

  changePrefecture () {
    if (this.prefectureId) {
      fetch(`/area/prefectures/${this.prefectureId}/cities.json`)
        .then(response => {
          if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)
          return response.json()
        })
        .then(cities => {
          this.updateCities(cities)
          this.citiesTarget.value = ''
        })
        .catch(error => {
          if (typeof Sentry !== 'undefined') {
            Sentry.captureException(error, { tags: { component: 'inquiry-form', operation: 'fetch-cities' } })
          }
          console.error('Failed to fetch cities:', error)
          alert('市区町村の取得に失敗しました。ページを再読み込みしてください。')
        })
    } else {
      this.citiesTarget.value = ''
    }
  }

  showPrefecturesModal (e) {
    const regionId = e.target.value
    fetch(`/area/regions/${regionId}/prefectures.json`)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)
        return response.json()
      })
      .then(prefectures => {
        this.updatePrefecturesModal(prefectures)
        this.modalPrefecturesTarget.style.display = 'block'
        this.modalAreaTarget.style.display = 'none'
      })
      .catch(error => {
        if (typeof Sentry !== 'undefined') {
          Sentry.captureException(error, { tags: { component: 'inquiry-form', operation: 'fetch-prefectures' } })
        }
        console.error('Failed to fetch prefectures:', error)
        alert('都道府県の取得に失敗しました。ページを再読み込みしてください。')
      })
  }

  showCitiesModal (e) {
    const prefectureId = e.target.value
    const findIndex = Array.from(this.prefecturesTarget.options).findIndex(option => option.value === prefectureId)
    this.prefecturesTarget.options[findIndex].selected = true
    fetch(`/area/prefectures/${prefectureId}/cities.json`)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)
        return response.json()
      })
      .then(cities => {
        this.updateCitiesModal(e, cities)
        this.updateCities(cities)
        this.modalCitiesTarget.style.display = 'block'
        this.modalPrefecturesTarget.style.display = 'none'
      })
      .catch(error => {
        if (typeof Sentry !== 'undefined') {
          Sentry.captureException(error, { tags: { component: 'inquiry-form', operation: 'fetch-cities-modal' } })
        }
        console.error('Failed to fetch cities:', error)
        alert('市区町村の取得に失敗しました。ページを再読み込みしてください。')
      })
  }

  choiceCity (e) {
    const findIndex = Array.from(this.citiesTarget.options).findIndex(option => option.value === e.target.value)
    this.citiesTarget.options[findIndex].selected = true
    this.modalOccupantTimingsTarget.style.display = 'block'
    this.modalCitiesTarget.style.display = 'none'
  }

  choiceFee (e) {
    const findIndex = Array.from(this.feeTarget.options).findIndex(option => option.value === e.target.value)
    this.feeTarget.options[findIndex].selected = true
    this.modalOccupantTimingsTarget.style.display = 'block'
    this.modalFeeTarget.style.display = 'none'
  }

  choiceOccupantTimings (e) {
    const findIndex = Array.from(this.occupantTimingsTarget.options).findIndex(option => option.value === e.target.value)
    this.occupantTimingsTarget.options[findIndex].selected = true
    this.modalDementiaTarget.style.display = 'block'
    this.modalOccupantTimingsTarget.style.display = 'none'
  }

  choiceDementia (e) {
    const findIndex = Array.from(this.dementiaTarget.options).findIndex(option => option.value === e.target.value)
    this.dementiaTarget.options[findIndex].selected = true
    this.modalProfileTarget.style.display = 'block'
    this.modalDementiaTarget.style.display = 'none'
  }

  inputTel (e) {
    this.telInputTarget.value = e.target.value
    this.validateTel()
  }

  updateCitiesModal (e, cities) {
    const action = this.modalCitiesContentTarget.dataset.nextAction
    const gtagEvent = this.modalCitiesContentTarget.dataset.gtag
    this.modalCitiesContentTarget.innerHTML =
      cities.map((city) => (
        `
          <li>
            <label>
              <input
                type="radio"
                name="inquiry[city_id]"
                value="${city.id}"
                data-action="${action}"
                onClick="${gtagEvent}"
              />
              ${city.name}
            </label>
          </li>
      `)).join('')
  }

  updatePrefecturesModal (prefectures) {
    const action = this.modalPrefecturesContentTarget.dataset.nextAction
    const gtagEvent = this.modalPrefecturesContentTarget.dataset.gtag
    const className = this.modalPrefecturesContentTarget.dataset.className
    this.modalPrefecturesContentTarget.innerHTML =
      prefectures.map(prefecture => (
        `
          <label class="${className}">
            <input
              type="radio"
              name="inquiry[prefecture_id]"
              value="${prefecture.id}"
              data-title="${prefecture.name}"
              data-action="${action}"
              onClick="${gtagEvent}"
            />
            <span>${prefecture.name}</span>
          </label>
        `
      )).join('')
  }

  validateTel () {
    const value = this.telInputTarget.value
    if (value) {
      const phoneNumber = parsePhoneNumber(value, 'JP')
      if (phoneNumber?.isValid()) {
        this.submitTarget.disabled = false
        this.telErrorTarget.style.display = 'none'
      } else {
        this.telErrorTarget.style.display = 'flex'
      }
    }
  }

  get prefectureId () {
    return this.prefecturesTarget.value
  }
}
